import { render, staticRenderFns } from "./DeviationApprovalModal.vue?vue&type=template&id=4465d66a&scoped=true&"
import script from "./DeviationApprovalModal.vue?vue&type=script&lang=js&"
export * from "./DeviationApprovalModal.vue?vue&type=script&lang=js&"
import style0 from "./DeviationApprovalModal.vue?vue&type=style&index=0&id=4465d66a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4465d66a",
  null
  
)

export default component.exports